// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "global-styles" + "." + "8ef82213e3b7073a4852" + ".css";
};